import { useQuery } from 'react-query'

import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { fetchCreditNote, type FetchDocument, type FetchDocumentData, fetchInvoice } from '../query-api'
import { getInvoiceQueryKey } from '../utils/getInvoiceQueryKey'

type RefetchInterval = false | number | ((data: FetchDocumentData | undefined) => number | false)

const fetchDocument: Partial<Record<InvoiceDocumentType, FetchDocument>> = {
  [InvoiceDocumentType.Invoice]: fetchInvoice,
  [InvoiceDocumentType.CreditNote]: fetchCreditNote,
}

export const useFetchInvoice = (
  documentType: InvoiceDocumentType,
  invoiceId?: string,
  refetchInterval: RefetchInterval = false,
) => {
  const fetcher = fetchDocument[documentType]

  const {
    data: invoiceData,
    isLoading,
    ...rest
  } = useQuery(getInvoiceQueryKey(invoiceId, documentType), () => fetcher?.(invoiceId ?? ''), {
    enabled: !!invoiceId && !!fetcher,
    refetchInterval,
  })

  return { invoice: invoiceData?.data, isLoading, ...rest }
}
